import InputGroup from "@/components/InputGroup";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { handleFormErrors } from "@/lib/handleFormErrors";
import toast from "@/lib/toast";
import {
  CompanyMemberResetPassword,
  companyMemberResetPasswordSchema,
} from "@/schema/console/companies/CompanyUser";
import { useResetCompanyMemberPassword } from "@/schema/console/companies/useResetCompanyMemberPassword";
import useMemberDialog from "@/src/console/(auth)/companies/[id]/_hooks/useMemberDialog";
import { SpinnerIosRegular } from "@fluentui/react-icons";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

function ResetMemberPasswordDialog() {
  const { t } = useTranslation();

  const { type, member, resetDialog } = useMemberDialog();
  const memberId = member?.id ?? -1;

  const methods = useForm<CompanyMemberResetPassword>({
    resolver: zodResolver(companyMemberResetPasswordSchema),
    defaultValues: {
      password: "",
    },
  });

  const {
    handleSubmit,
    formState: { errors, isDirty },
    register,
    setError,
  } = methods;

  const { trigger: editMember, isMutating } = useResetCompanyMemberPassword(
    memberId,
    {
      onSuccess: (data) => {
        resetDialog();
        toast.success(data.message);
      },
      onError: (error) => {
        handleFormErrors(error.errors, setError);
      },
    },
  );

  return (
    <Dialog
      open={type === "reset-password"}
      onOpenChange={(open) => !open && resetDialog()}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("change-password")}</DialogTitle>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit((data) => {
              console.log(data);
              editMember(data);
            })();
          }}
        >
          <div className="flex flex-col gap-6 px-6 pb-5 pt-4">
            <InputGroup
              label={t("password")}
              type="password"
              error={errors.password?.message}
              register={register("password", {
                required: t("password-required"),
              })}
            />
            <Button
              LoadingComponent={<SpinnerIosRegular className="animate-spin" />}
              isLoading={isMutating}
              type="submit"
              disabled={!isDirty}
            >
              {t("change-password")}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default ResetMemberPasswordDialog;
